import SurveyDaysAdditionalDetailsViewModel from "./SurveyDaysAdditionalDetailsViewModel";

export default class SurveyViewModel {
    id: string = '';
    releaseVersion: string = '';
    comments: string = '';
    surveyType: string = '';
    arrivals: (number | null)[] = [];
    departures: (number | null)[] = [];
    initialParking: number | null = 0;
    finalParking?: number = 0;
    vehicleOccupancyArrivals?: string[] = [];
    vehicleOccupancyDepartures?: string[] = [];
    additionalDetails: SurveyDaysAdditionalDetailsViewModel = new SurveyDaysAdditionalDetailsViewModel();
}

